// Generated with util/create-component.js
import Select from './Select';

export default Select;
